// group sections and add children
export const groupSections = fields => {
  let currentSection = null;
  const parsedFields = [];

  fields.forEach(field => {
    const { type, section_heading } = field;
    const isSectionStart = type === "section";
    const isSectionComplete = currentSection && isSectionStart;

    if (isSectionComplete) {
      currentSection = null;
    }

    if (currentSection) {
      currentSection.innerFields.push(field);
    } else if (isSectionStart) {
      currentSection = {
        ...field,
        name: section_heading,
        innerFields: [],
      };
      parsedFields.push(currentSection);
    } else {
      parsedFields.push(field);
    }
  });

  return parsedFields;
};
